(() => {
  const privacySections = new Set([
    'Types of Data collected',
    'How we collect your Data',
    'How do we use your data?',
    'The purposes of processing',
    'Detailed information on the processing of Personal Data',
    'Legal basis of processing personal Information',
    'The rights of Users',
    'Information for Californian consumers',
    'Cookie Policy',
    'Changes to this privacy policy',
    'Definitions',
    'How to contact us'
  ]);

  const slugify = (text, index) => {
    const slug = text
      .toLocaleLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '')
      .slice(0, 54);
    return `policy-section-${slug || index + 1}`;
  };

  const initialize = (layout) => {
    if (!layout || layout.dataset.policyLegalReady === 'true') return;

    const article = layout.querySelector('.ink-policy__generic .rte') || layout.querySelector('.ink-policy__generic');
    const toc = layout.querySelector('[data-policy-toc]');
    const panel = layout.querySelector('[data-policy-toc-panel]');
    if (!article || !toc || !panel) return;

    layout.dataset.policyLegalReady = 'true';

    const firstHeading = article.querySelector('h1, h2');
    if (firstHeading) firstHeading.classList.add('ink-policy__source-title');

    const paragraphs = Array.from(article.querySelectorAll('p'));
    const termsTitle = paragraphs.find((paragraph) => paragraph.textContent.trim().toLocaleLowerCase() === 'terms of service');
    if (termsTitle) termsTitle.classList.add('ink-policy__source-title');

    const majorHeadings = [];

    paragraphs.forEach((paragraph) => {
      const text = paragraph.textContent.trim();
      const strongOnly = paragraph.children.length === 1 && paragraph.firstElementChild?.tagName === 'STRONG';
      const numberedTerm = /^\d+\.\s+\S/.test(text) && text.length < 90;

      if (strongOnly && text.length < 110) {
        paragraph.classList.add('ink-policy__legal-heading');
      }

      if (privacySections.has(text) || numberedTerm) {
        paragraph.classList.add('ink-policy__legal-heading', 'ink-policy__legal-heading--major');
        majorHeadings.push(paragraph);
      }
    });

    const usedIds = new Set();
    majorHeadings.slice(0, 14).forEach((heading, index) => {
      const text = heading.textContent.trim();
      let id = slugify(text, index);
      while (usedIds.has(id) || document.getElementById(id)) id = `${id}-${index + 1}`;
      usedIds.add(id);
      heading.id = id;

      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = text.replace(/^\d+\.\s*/, '');
      toc.appendChild(link);
    });

    if (toc.children.length) panel.hidden = false;
  };

  const initializeAll = () => document.querySelectorAll('[data-ink-policy-legal]').forEach(initialize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }
})();
